export default {
  vertical: "bottom",
  horizontal: "center"
};
